import {
  Grid,
  makeStyles,
  Theme,
  Typography,
  useTheme,
} from '@material-ui/core';
import AutoCard from 'components/AutoCard';
import React from 'react';
import styles, { overrideCard } from './styles';

const useStyles = makeStyles(styles);

interface AdvisorCardProps {
  title: string;
  content: React.ReactNode;
  footer?: React.ReactNode;
}

const AdvisorCard = ({ title, content, footer }: AdvisorCardProps) => {
  const classes = useStyles();
  const { breakpoints }: Theme = useTheme();

  return (
    <AutoCard overrideClasses={overrideCard(breakpoints)}>
      <Grid container alignItems="center">
        <Grid item>
          <Typography className={classes.title}>{title}</Typography>
        </Grid>
        <Grid container justify="center" className={classes.content}>
          {content}
        </Grid>
        <Grid container className={classes.iconGrid}>
          {footer}
        </Grid>
      </Grid>
    </AutoCard>
  );
};

export default AdvisorCard;
